
<template>
  <div id="app">
    <h1>Hello World {{ fullname }} </h1>
    <p>little text behind the title</p>
  </div>
</template>

<script>
module.exports = {
  data: function() {
    return {
      firstname: 'Pierre',
      lastname: 'Fay'
    }
  },
  computed: {
    fullname: function () {
      return this.firstname + ' ' + this.lastname
    }
  }
}
</script>